module.exports = __webpack_public_path__ + "img/discover_world_map@2x.d492781.webp";